<app-layout heading="Projects & Code">
    <div class="d-flex flex-row justify-content-center py-3">
        <fa-icon [icon]="code1" class="fa-5x mx-3"></fa-icon>
        <fa-icon [icon]="code3" class="fa-5x mx-3"></fa-icon>
        <fa-icon [icon]="code2" class="fa-5x mx-3"></fa-icon>
    </div>
    <div class="h2 font-oxygen text-center my-3">
        All projects are available on:<i class="fa fa-github fa-2x m-2"></i>
        <a href="https://github.com/tanaytoshniwal" target="_blank">github.com/tanaytoshniwal</a>
    </div>
    <div class="container-fluid justify-content-center text-center row mx-auto">
        <div class="col-sm-8 col-10 px-3">
            <div class="input-group text-center justify-content-center align-items-center">
                <span class="font-raleway filter-text mr-2 d-inline">Filter Category:</span>
                <div class="myselect d-inline m-2 justify-content-center align-items-center pt-2">
                    <div class="font-oxygen select-display px-2" (click)="flip()" id="myselect" [ngClass]="{ under: show_list }">
                        <span>{{ selected_filter }}</span>
                        <fa-icon [icon]="faChevronDown" class="filter-down float-right mb-2"></fa-icon>
                    </div>
                    <ul class="select-options depth p-0" *ngIf="show_list" [ngStyle]="{ width: dropdown_width }">
                        <li
                            *ngFor="let category of categories; let i = index"
                            class="myselect-item px-3 py-3"
                            [ngClass]="{
                                'theme-light text-light back-light': themeService.flag,
                                'bg-light': !themeService.flag
                            }"
                            (click)="apply(i)"
                        >
                            {{ category }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="h2 font-oxygen text-center my-3">Selected Repositories/Projects:</div>
    <div class="row justify-content-center">
        <div class="p-2 cards" *ngFor="let project of selected; let i = index">
            <div
                class="card my-card depth"
                [ngClass]="{
                    'theme-light text-light border-light': themeService.flag
                }"
            >
                <div
                    class="card-header justify-content-center d-flex"
                    [ngClass]="{
                        'theme-light text-light border-light': themeService.flag
                    }"
                >
                    <img [src]="project.logo" [alt]="project.title" class="card-img-top rounded img-fluid" />
                </div>
                <div class="card-body p-1">
                    <h4 class="card-title font-oxygen text-center my-2 h4">
                        {{ project.title }}
                    </h4>
                    <h6 class="font-oxygen text-center h6">
                        {{ project.info }}
                    </h6>
                </div>
                <div class="options justify-content-center p-2">
                    <div class="dropdown-divider my-1" [ngClass]="{ 'border-light': themeService.flag }"></div>
                    <div
                        class="text-center d-inline-block p-0 py-2 font-raleway text-danger"
                        [ngClass]="{
                            'col-6': project.link_available,
                            'col-12': !project.link_available
                        }"
                    >
                        <a (click)="open(project.id)" class="red">VIEW DETAILS</a>
                    </div>
                    <div *ngIf="project.git && project.link_available" class="text-center col-6 d-inline-block p-0 py-2 font-raleway text-secondary">
                        <a [href]="project.link" target="_blank">GITHUB</a>
                    </div>
                    <div *ngIf="!project.git && project.link_available" class="text-center col-6 d-inline-block p-0 py-2 font-raleway text-secondary">
                        <a [href]="project.link" target="_blank">LINK</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="h2 font-oxygen text-center my-3">Other Projects:</div>
    <div class="row justify-content-center">
        <div class="p-2 cards" *ngFor="let project of projects; let i = index">
            <div
                class="card my-card depth"
                [ngClass]="{
                    'theme-light text-light border-light': themeService.flag
                }"
            >
                <div
                    class="card-header justify-content-center d-flex"
                    [ngClass]="{
                        'theme-light text-light border-light': themeService.flag
                    }"
                >
                    <img [src]="project.logo" [alt]="project.title" class="card-img-top rounded img-fluid" />
                </div>
                <div class="card-body p-1">
                    <h4 class="card-title font-oxygen text-center my-2 h4">
                        {{ project.title }}
                    </h4>
                    <h6 class="font-oxygen text-center h6">
                        {{ project.info }}
                    </h6>
                </div>
                <div class="options justify-content-center p-2">
                    <div class="dropdown-divider my-1" [ngClass]="{ 'border-light': themeService.flag }"></div>
                    <div
                        class="text-center d-inline-block p-0 py-2 font-raleway text-danger"
                        [ngClass]="{
                            'col-6': project.link_available,
                            'col-12': !project.link_available
                        }"
                    >
                        <a (click)="open(project.id)" class="red">VIEW DETAILS</a>
                    </div>
                    <div *ngIf="project.git && project.link_available" class="text-center col-6 d-inline-block p-0 py-2 font-raleway text-secondary">
                        <a [href]="project.link" target="_blank">GITHUB</a>
                    </div>
                    <div *ngIf="!project.git && project.link_available" class="text-center col-6 d-inline-block p-0 py-2 font-raleway text-secondary">
                        <a [href]="project.link" target="_blank">LINK</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-layout>
